// extracted by mini-css-extract-plugin
export default {"title":"BjhSLwoQCAMo5N1oM9s7","viewPlanDetails":"ybU2FZHNchu9Y09P6NTA"};